import React from 'react';
import NotFoundSrc from 'assets/images/404.png';
import NotFoundBackdropSrc from 'assets/images/404-backdrop.png';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import withErrorBoundary from 'hocs/withErrorBoundary';

const PageNotFound = (): JSX.Element => (
  <Box
    sx={{
      alignItems: 'center',
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
      position: 'absolute',
      width: '100%',

      '.img-backdrop': {
        bottom: '10%',
        left: 0,
        m: 'auto',
        maxWidth: 1200,
        position: 'absolute',
        right: 0,
        top: 0,
        width: '100%',
        zIndex: -1,
      },
    }}
  >
    <img
      className='img-backdrop'
      src={NotFoundBackdropSrc}
      alt='Page not found'
    />

    <Stack alignItems='center'>
      <img className='img-main' src={NotFoundSrc} alt='Page not found' />
      <Typography sx={{ mb: 4, mt: 2 }} variant='h4'>
        This page does not exist
      </Typography>
      <Button component={Link} to='/' variant='contained'>
        Back to home
      </Button>
    </Stack>
  </Box>
);

export default withErrorBoundary(PageNotFound);
